import { GenericObject, copyFields } from '@synergy/models';

import { User } from './user';

export class ActivityComment {
    public id!: number;
    public text!: string;
    public createdAt!: string;
    public createdBy!: User;
    public updatedAt?: string;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): ActivityComment {
        const comment = new ActivityComment();

        copyFields(object, comment);

        if (object['createdBy']) {
            comment.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            comment.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        return comment;
    }
}
